module.exports = __webpack_public_path__ + "static/media/playline-live.7211e936.png";